/**
 * reduxを導入するコード
 */

import { createStore as reduxCreateStore, combineReducers, applyMiddleware } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { MainPageReducer } from '../mainPage/reducers';
import { CleaningPlaceReducer } from '../cleaningPlace/reducers';
import { LoadingReducer } from '../loading/reducers';
import { UserReducer } from '../users/reducers';

export default function createStore(history) {
    return reduxCreateStore(
        combineReducers({
            router: connectRouter(history),
            mainpage: MainPageReducer,
            cleaningPlace: CleaningPlaceReducer,
            loading: LoadingReducer,
            user: UserReducer,
        }),
        applyMiddleware(
            routerMiddleware(history),
            thunk
        )
    )
}